export default __webpack_public_path__ + "static/media/banner1.c75be89b.png";